import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { DisplayImage } from '../../../widgets/components/General/DisplayImage'
import { deleteMeetings, getAgenda, getMeetings, getParticipants, updateMeetings } from '../../core/_requests'
import { getFileType, toTitleCase } from '../../core/_util'
import { useIntl } from "react-intl"
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton'
import { useDateFormat } from '../../../../hooks/useDateFormat'
import { useTimeZone } from '../../../../hooks/useTimeZone'
import { useAuth } from '../../../auth'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../hooks/gtmHelpers'
import NoDataPage from '../../../widgets/components/NoDataPage'
export default function MeetingInterfaceEditable({ setSidebar, meetingId }: any) {
  const { formatMessage } = useIntl()
  const { currentUser, companyId } = useAuth()
  const navigate = useNavigate()
  const [agendaData, setAgendaData] = useState<any>([])
  const [participantsData, setParticipantsData] = useState<any>([])
  const [meetingDetails, setMeetingDetails] = useState<any>()
  const [organizer, setOrganizer] = useState<any>()
  const [loading, setLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { getDateValue } = useDateFormat()
  const { getTimeZoneValue } = useTimeZone()
  const timeZone = localStorage.getItem('timeZone')
  const getMeetingAgenda = async () => {
    try {
      const {
        data: { success, data },
      } = await getAgenda(meetingId, true)
      if (success) {
        setAgendaData(data.data)
        getMeetingParticipant()
      }
    } catch (err) {
      console.log(err)
    }
  }
  const getMeetingParticipant = async () => {
    try {
      const {
        data: { success, data },
      } = await getParticipants(meetingId, true)
      if (success) {
        const responseData = data.data.map((item: any) => {
          let badge;
          if (item.type === 'Host' || item.type === 'Co-Host')
            badge = 'primary';
          else if (item.type === 'Guest')
            badge = 'warning';
          else if (item.type === 'Observer')
            badge = 'success';
          else if (item.type === 'Organizer')
            badge = 'info'
          else if (item.type === 'Participant')
            badge = 'danger'
          else
            badge = 'warning'

          return {
            ...item,
            badge
          };
        });
        setParticipantsData(responseData)
        setOrganizer(data.data.find((item: any) => item.type === 'Organizer'))
        setLoading(true)
      }
    } catch (err) {
      console.log(err)
    }finally{
      setLoading(false)
    }
  }
  const getMeetingDetails = async () => {
    try {
      const {
        data: { success, data },
      } = await getMeetings(meetingId)

      if (success) {
        setMeetingDetails(data)
        await getMeetingAgenda()
      }
    } catch (err) {
      console.log(err)
    }
  }
  const callApis = async () => {
    if (meetingId) {
      await getMeetingDetails()
    }
  }
  useEffect(() => {
    callApis()
  }, [meetingId])// eslint-disable-line react-hooks/exhaustive-deps

  const cancelMeeting = async () => {
    try {
      const {
        data: { success, error },
      } = await deleteMeetings(meetingId)
      if (success) {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.BoardMeetingCancelledSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meeting_id: meetingId,
            },
          },
        })
        navigate(`/compliance-meeting`)
      }
      else {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.BoardMeetingCancelFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meeting_id: meetingId,
              error: error[0]
            },
          },
        })
      }
    } catch (err) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.BoardMeetingCancelFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            meeting_id: meetingId,
            error: err
          },
        },
      })
    }
  }
  const setSchedule = async () => {
    try {
      setIsLoading(true)
      const organizer = participantsData.filter((data: any) => data.type === 'Organizer')
      if (organizer.length >= 1) {
        const {
          data: { success, error },
        } = await updateMeetings({ schedule: true, dateFormat: localStorage.getItem('dateFormat') }, meetingId)
        if (success) {
          setIsLoading(false)
          if (meetingDetails?.schedule) {
            toast.success(formatMessage({ id: 'Meeting updated successfully.' }))
          }
          else
            toast.success(formatMessage({ id: 'Meeting created successfully.' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateBoardMeetingInitiationSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                meeting_id: meetingId,
              },
            },
          })
          navigate(`/compliance-meeting`)
        }
        else {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateBoardMeetingInitiationFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                meeting_id: meetingId,
                error: error[0]
              },
            },
          })
        }
      }
      else {
        toast.error(formatMessage({ id: 'Add participants or an organizer to the meeting.' }))
        setSidebar(3)
      }
    } catch (e) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.UpdateBoardMeetingInitiationFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            meeting_id: meetingId,
            error: e
          },
        },
      })
    }finally{
      setIsLoading(false)
    }
  }
  return (
    <>
      {
        !loading && !meetingDetails ?
          <div className='my-5 mx-6'>
            <NoDataPage width={'w-0'} />
          </div>
          : loading ?
            <>
              <Skeleton
                height={44}
                count={6}
                width={'100%'}
                className='my-1'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
              <Skeleton
                height={'70%'}
                count={1}
                width={'100%'}
                className='mt-4'
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </>
            : <>
              <div className='rounded-2 mb-6'>
                <div className='d-flex flex-column flex-md-row justify-content-between align-items-start'>
                  <div>
                    <h2>{meetingDetails?.meetingTitle} | {toTitleCase(meetingDetails?.category)}</h2>
                    <p>{getDateValue(meetingDetails?.meetingDate.toString())} {` | ${getTimeZoneValue(meetingDetails?.startTime.toString())} - ${getTimeZoneValue(meetingDetails?.endTime.toString())}`} {`(${timeZone})`}</p></div>
                  <div className='d-flex flex-column flex-md-row gap-2 w-100 w-md-auto'>
                    <button className='btn btn-primary w-100 w-md-auto mt-2 mt-md-0' onClick={() => { setSidebar(2) }}>{formatMessage({ id: 'Edit' })}</button>
                  </div>
                </div>
                <div className='d-flex flex-row'>
                  {meetingDetails?.venue && meetingDetails.type === 'Physical Meeting' &&
                    < div className='mt-5 w-50'>
                      <h5>{formatMessage({ id: 'Meeting Venue' })}</h5>
                      <p className='text-primary cursor-pointer'>{meetingDetails?.venue}</p>
                    </div>
                  }
                  <div className='mt-5'>
                    <h5>{formatMessage({ id: 'Meeting URL' })}</h5>
                    <p className='text-primary cursor-pointer'>{meetingDetails?.link}</p>
                    {/* <button className='btn btn-primary w-100 w-md-auto'>Start Meeting</button> */}
                  </div>
                </div>

                <div className='mt-5'>
                  <h5>{formatMessage({ id: "Organizer" })}</h5>
                  <div className='d-flex'>
                    <DisplayImage
                      imgName={organizer && organizer?.profileImage?.name ? organizer.profileImage.name : organizer?.email === currentUser?.email ? currentUser?.profileImg : 'dummy'}
                      alt='profile'
                      fit='cover'
                      className='rounded-circle mt-2'
                      width={32}
                      height={32}
                    />
                    {organizer && <div className='ms-4'><p className='m-0'>{toTitleCase(organizer?.name)}</p>
                      <p className='m-0'>{organizer?.isGuest ? 'Guest' : 'Shareholder'}</p></div>}
                  </div>
                </div>

                {meetingDetails?.description &&
                  <div className='mt-5 w-100'>
                    <h5>{formatMessage({ id: "Description" })}</h5>
                    <p className='text-muted' style={{ 'wordBreak': 'break-word' }}>
                      {meetingDetails?.description}
                    </p>
                  </div>}


                {meetingDetails?.notes && <div className='mt-5 w-100' >
                  <h5>{formatMessage({ id: "Notes for participants" })}</h5>
                  <p className='text-muted' style={{ 'wordBreak': 'break-word' }}>
                    {meetingDetails?.notes}
                  </p>
                </div>}

                <div className='mt-5 alert alert-warning' role='alert'>
                  <p className='pb-0 text-body m-0'>
                    <span className='fw-bolder'>{formatMessage({ id: 'Note:' })}</span> {formatMessage({ id: 'Meeting invitations will be sent instantly to the members. Remember, you can modify meeting details at any time.' })}
                  </p>
                </div>

                <Row>
                  <Col md={6} sm={12}>
                    <div
                      className='border border-1 p-4 rounded-2 mt-4'
                      style={{ height: '400px', overflow: 'hidden' }}
                    >
                      <div className='d-flex justify-content-between align-items-center'>
                        <h5 className='mt-2 mb-4'>{formatMessage({ id: 'Agenda' })}</h5>
                        {agendaData && <button className='btn btn-primary py-2 mb-2' onClick={() => { setSidebar(4) }}>{formatMessage({ id: "Edit" })}</button>}
                      </div>
                      <div className='seperator bg-dark border'></div>

                      <div className='mt-2' style={{ overflowY: 'auto', maxHeight: '330px' }}>
                        {agendaData.map((agenda: any) => (
                          <div className='d-flex align-items-center justify-content-between pt-4' key={agenda.agendaId}>
                            <div className='d-flex align-items-center col-5'>
                              <div className='d-flex align-items-center gap-2'>
                                <div className=''>
                                  <p className='mb-0 font-size-13' style={{ whiteSpace: 'nowrap', width: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{agenda.agendaTitle}</p>
                                  <div className='d-flex align-items-center gap-6'>
                                    {agenda.presenter && <p className='mb-0 font-size-12 text-muted' style={{ 'wordBreak': 'break-word' }}>
                                      {`Presenter: ${toTitleCase(agenda.presenter)}`}
                                    </p>}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p className='mb-0 font-size-12 text-muted col-2'>{`${agenda.assignedTime.split(' ')[0]} mins`}</p>
                            <div className='d-flex flex-start col-5'>
                              {agenda.AgendaDocuments.length > 0 ? agenda?.AgendaDocuments.slice(0, agenda?.AgendaDocuments.length > 2 ? 2 : agenda?.AgendaDocuments.length).map((doc: any) => (
                                <>
                                  <img
                                    key={doc.documentsId}
                                    src={getFileType(doc.file.name)}
                                    alt='Document icon'
                                    width={32}
                                    height={32}
                                  />
                                </>
                              )) : "No files"}
                              {
                                agenda.AgendaDocuments?.length > 2 && (
                                  <span className='ms-2'>
                                    {`& ${agenda.AgendaDocuments?.length - 2 === 1 ? '1 more file' : `${agenda.AgendaDocuments?.length - 2} more files`}`}
                                  </span>
                                )
                              }
                            </div>
                          </div>
                        ))}
                        {/* Add more participants here to test scrolling */}
                      </div>
                    </div>
                  </Col>
                  <Col md={6} sm={12}>
                    <div
                      className='border border-1 p-4 rounded-2 mt-4'
                      style={{ height: '400px', overflow: 'hidden' }}
                    >
                      <div className='d-flex justify-content-between align-items-center'>
                        <h5 className='mt-2 mb-4'>{formatMessage({ id: "Participants" })} ({participantsData?.length})</h5>
                        <button className='btn btn-primary py-2 mb-2' onClick={() => { setSidebar(3) }}>{formatMessage({ id: "Edit" })}</button>
                      </div>
                      <div className='seperator bg-dark border'></div>

                      <div className='mt-2' style={{ overflowY: 'auto', maxHeight: '330px' }}>
                        {participantsData.map((participant: any) => (
                          <div className='d-flex align-items-center justify-content-between pt-4' key={participant.meetingParticipantId}>
                            <div className='d-flex align-items-center col-8'>
                              <div className='d-flex align-items-center gap-2'>
                                <DisplayImage
                                  imgName={participant.profileImage.name ? participant.profileImage.name : participant.email === currentUser?.email ? currentUser?.profileImg : 'dummy'}
                                  alt='profile'
                                  fit='cover'
                                  className='rounded-circle'
                                  width={32}
                                  height={32}
                                />
                                <div className='' style={{ 'wordBreak': 'break-word' }}>
                                  <p className='mb-0 font-size-13'>{toTitleCase(participant.name)}</p>
                                  <p className='mb-0 font-size-12 text-muted'>{participant.email}{participant.isGuest ? ' . Guest' : ' . Shareholder'}</p>
                                </div>
                              </div>
                            </div>
                            <div className={`badge alert-${participant.badge} px-4 py-2 w-100px col-2`}><span className='flex-root'>{participant.type}</span></div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className='d-flex flex-md-row flex-column gap-3 justify-content-end mt-4'>
                  <div className="d-md-flex justify-content-start">
                    {!meetingDetails.schedule && <button
                      className='btn btn-light fw-normal py-4 w-100 w-md-auto order-md-1 order-2'
                      style={{ width: '120px' }}
                      type="button"
                      onClick={cancelMeeting}  // For resetting the form
                    >
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({ id: 'Discard' })}
                      </span>
                    </button>}
                  </div>
                  <div className="d-md-flex gap-3 justify-content-end">
                    <button
                      className='btn btn-light fw-normal py-4 w-100 w-md-auto order-md-2 order-2'
                      style={{ width: '140px' }}
                      type="button"
                      onClick={() => { setSidebar(4) }}  // For resetting the form
                    >
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({ id: 'Prev' })}
                      </span>
                    </button>
                    <button
                      className='btn btn-primary fw-normal py-4 w-100 w-md-auto order-md-3 order-1'
                      // disabled={!formik.isValid || !formik.dirty}
                      style={{ width: '140px' }}
                      type='button'
                      disabled={isLoading}
                      onClick={() => {
                        setSchedule()
                      }}
                    >
                      <span className='indicator-label font-size-13 p-0'>
                        {isLoading ? formatMessage({ id: 'Please wait...' }) : formatMessage({ id: 'Schedule' })}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </>
      }
    </>
  )
}

